// extracted by mini-css-extract-plugin
export default {"Box":"NewSponsor_Box__lm8BS","SponsorBox":"NewSponsor_SponsorBox__EBMZw","BoxInnerHeader":"NewSponsor_BoxInnerHeader__TQEXH","BoxHeader":"NewSponsor_BoxHeader__GdAKi"};